<mat-form-field appearance="fill" class="component-box alight-drop-down" [formGroup]="group" [ngClass]="{'error-border':required}">
  
    <mat-label>{{label}}{{required?" (Required)":""}}</mat-label>
    <mat-select disableRipple [formControlName]="controlName" [disabled]='disable'  [appAutoFocus]="autofocus" 
        disableOptionCentering id="{{label}}" (selectionChange)="typeHeadChange($event)" (openedChange)='openDropDown()' >
        <mat-option class="custom-option" *ngFor="let item of list | sortBy:description" [name]="item[description]" [title]="item[description]" [value]="item[value]">
            {{item[description]}}
        </mat-option>
    </mat-select>
    <mat-error *ngIf="required&&group.controls[controlName].hasError('required')">
        <f-icon icon-config='{"iconName": "circle-xmark", "iconType": "solid", "iconSize": "s"}'></f-icon>
        You must first select a {{label}}. </mat-error>
</mat-form-field>